import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: null,
  currentPage: 1,
  totalPages: 1,
};

const filterList = (list, key, value) => {
  return list.filter((user) => {
    return !user.hasOwnProperty(key) || user[key] !== value;
  });
};

export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setList: (state, action) => {
      state.list = action.payload;
    },
    appendToList: (state, action) => {
      state.list.push(action.payload);
    },
    removeFromListByIndex: (state, action) => {
      state.list.splice(action.payload, 1);
    },
    removeFromListById: (state, action) => {
      state.list = filterList(state.list, "id", action.payload);
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
  },
});

export const {
  setList,
  appendToList,
  removeFromListByIndex,
  removeFromListById,
  setCurrentPage,
  setTotalPages,
} = userSlice.actions;

export default userSlice.reducer;
